module.exports = __webpack_public_path__ + "0b9479c166150886106ffcbed6bed50f.jpg";